
import { dispatch } from '../index.js'
import {actionTypes} from '../../config'

export const dispatchUsers = users => {
  
    return dispatch({type: actionTypes.DISPATCH_USERS, payload: users})
}